import { render, staticRenderFns } from "./edit_home.vue?vue&type=template&id=3b6d40a0&scoped=true&"
import script from "./edit_home.vue?vue&type=script&lang=js&"
export * from "./edit_home.vue?vue&type=script&lang=js&"
import style0 from "./edit_home.vue?vue&type=style&index=0&id=3b6d40a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6d40a0",
  null
  
)

export default component.exports